const twoFactorAuthEN = {
    "view": {
        "title": "Two-Factor Authentication",
        "form": {
            "label": {
                "currentMethod": "Current Two-Factor Method",
                "authenticatorSetupTitle": "Set up your Authenticator App",
                "scanInstructions": "Scan the QR code below using any TOTP Authenticator app (like Authy, Google Authenticator, Microsoft Authenticator etc).",
                "qrCodeAlt": "QR Code for authenticator setup",
                "step1": "Open your authenticator app.",
                "step2": "Select the option to add a new account.",
                "step3": "Choose the \"Scan a QR code\" option in the app.",
                "step4": "Point your phone's camera at the QR code above.",
                "step5": "Once scanned, authenticator will start generating 6-digit OTP Code that refresh every 30 seconds. This OTP Code can be used to complete the login process.",
                "appLinks": "Here are the links for some common authenticator apps:",
                "appLinksAuthy": "Authy",
                "appLinksGoogle": "Google Authenticator",
                "appLinksMicrosoft": "Microsoft Authenticator",
                "googlePlay": "Google Play Store",
                "appStore": "Apple App Store",
                "loadingQrCode": "Loading QR code...",
                "emailSetupTitle": "Email Two-Factor Authentication",
                "emailDescription": "You will receive a One-Time Password (OTP) on your registered email address, which can be used to complete the login process. Make sure to check your email inbox or spam folder for the OTP when logging in."

            },
            "help_text": {
                "currentMethod": "Email is currently set as the default method for Two-Factor Authentication. However, we recommend using the Authenticator method for enhanced security.",
            },
            "option": {
                "2faMethod": {
                    "selectMethod": "Select 2FA Method",
                    "email": "Email",
                    "auth": "Authenticator"
                }
            },
            "button": {
                "save": "Save",
                "saving": "Saving..."
            }
        },
        "backupCodes": {
            "title": "Backup Codes",
            "view": {
                "button": {
                    "generate": "Generate Backup Codes",
                    "download": "Download Backup Codes"
                },
                "modal": {
                    "header": "Your Backup Codes",
                    "body": {
                        "noCodes": "No backup codes available"
                    }
                }
            }
        }
    },
};

export default twoFactorAuthEN;